import React, { useEffect } from "react";

import "./style.scss";

interface Props {
  style?: React.CSSProperties;
}

const Footer = (props: Props) => {
  const { style = {} } = props;

  useEffect(() => {}, []);

  return (
    <div style={style} className="good_use-footer">
      <p>
        {`©${new Date().getFullYear()} 机器之心（北京）科技有限公司`}
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          {window._config.var.beian}
        </a>
      </p>
    </div>
  );
};

export default Footer;
